import { ApiNewDokumentPowiazanyDalDto, EgibObject } from '@gk/gk-modules';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { WorkspaceState } from '../../../../services/request-workspace-state/request-workspace-state.model';
import {
  DocumentationFormType,
  ExtendedApplicantRequest,
  ExtendedApplicantRequestDto,
} from '../../../../shared/base-new-request/base-new-request.model';
import { InvestorDetails } from '../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';
import { DateHelperUtil } from '../../../../utils/date-helper/date-helper.util';

export interface INWEPCombustionSourceDto {
  KodDzialalnosci: string;
  Regon: string;
  MocSpalaniaMW: number;
  RodzajZrodelSpalania: string;
  RodzajUdzialPaliw: string;
  StandardyEmisyjne: string;
  DataOddaniaDoUzytku: string;
  CzasObciazenieOpis: string;
}

export interface INWEPNewRequestDto extends ExtendedApplicantRequestDto {
  OpisProwadzonejDzialalnosci: string;
  CzasFunkcjonowaniaInstalacji: string;
  WielkoscRodzajEmisji: string;
  MetodyOgraniczeniaEmisji: string;
  CzyOgraniczenieZgodneZPrzepisami: string;
  ZrodloSpalania?: INWEPCombustionSourceDto;
}

export class INWEPCombustionSource {
  constructor(
    public businessActivityCode: string,
    public regon: string,
    public combustionPower: number,
    public combustionSourceType: string,
    public fuelShareType: string,
    public emissionStandards: string,
    public commissionDate: NgbDate,
    public loadTimeDescription: string,
  ) {}

  static fromAppToApi(data: INWEPCombustionSource): INWEPCombustionSourceDto {
    return {
      KodDzialalnosci: data.businessActivityCode,
      Regon: data.regon,
      MocSpalaniaMW: data.combustionPower,
      RodzajZrodelSpalania: data.combustionSourceType,
      RodzajUdzialPaliw: data.fuelShareType,
      StandardyEmisyjne: data.emissionStandards,
      DataOddaniaDoUzytku: DateHelperUtil.ngbDateToApiDateTime(
        data.commissionDate,
      ),
      CzasObciazenieOpis: data.loadTimeDescription,
    };
  }
}

export class INWEPNewRequest extends ExtendedApplicantRequest {
  constructor(
    investorDetails: InvestorDetails,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    proxyDetailsCheckbox: boolean,
    proxyDetailsArray: InvestorDetails[],
    public activityDescription: string,
    public installationOperatingTime: string,
    public emissionTypeAndAmount: string,
    public emissionReductionMethods: string,
    public reductionCompliantDescription: string,
    public combustionSource?: INWEPCombustionSource,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      proxyDetailsCheckbox,
      proxyDetailsArray,
    );
  }

  static fromAppToApi(
    data: INWEPNewRequest,
    parcels: EgibObject[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): INWEPNewRequestDto {
    return {
      ...ExtendedApplicantRequest.mapCommonFields({
        data,
        files,
        parcels,
      }),
      OpisProwadzonejDzialalnosci: data.activityDescription,
      CzasFunkcjonowaniaInstalacji: data.installationOperatingTime,
      WielkoscRodzajEmisji: data.emissionTypeAndAmount,
      MetodyOgraniczeniaEmisji: data.emissionReductionMethods,
      CzyOgraniczenieZgodneZPrzepisami: data.reductionCompliantDescription,
      ZrodloSpalania: data.combustionSource
        ? INWEPCombustionSource.fromAppToApi(data.combustionSource)
        : undefined,
    };
  }
}

export interface INWEPNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: INWEPNewRequest;
  parcels: EgibObject[];
}
